import { makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

export const StyledButton = makeUclComponent(ActionButton).withConfig({
  _text: {
    fontSize: 'xl',
    textAlign: 'center',
  },
});
